import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

// hooks
import usePlaidLink from '../hooks/usePlaidLink';

const styles = ({ palette }) => ({
  link: {
    color: palette.mycc.link,
    cursor: 'pointer',
  },
});

const PlaidLink = props => {
  const { token, classes, onExit, onSuccess, setSelected, bank } = props;
  const [openPlaid, plaidReady] = usePlaidLink(onSuccess, onExit, token);
  return (
    <Link
      disabled={!plaidReady}
      className={classes.link}
      onClick={() => {
        setSelected(bank);
        openPlaid();
      }}
    >
      Verify Now
    </Link>
  );
};

export default withStyles(styles)(PlaidLink);
